import { render } from "./OutboundItemsFormView.vue?vue&type=template&id=2eb0c3fc"
import script from "./OutboundItemsFormView.vue?vue&type=script&lang=js"
export * from "./OutboundItemsFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__